import { render, staticRenderFns } from "./parkregion.vue?vue&type=template&id=50079942&"
import script from "./parkregion.vue?vue&type=script&lang=js&"
export * from "./parkregion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports